module.exports = __webpack_public_path__ + "static/media/Translation Background.225cea9c.md";